<template>
  <NuxtLink
    :to="collection.url"
    class="group"
  >
    <span class="relative flex aspect-video flex-col overflow-hidden rounded-md">
      <ContentExperienceImage v-bind="collection.image" />
      <span
        v-if="allNew || (isLoggedIn && collection.is_new)"
        class="absolute right-3 top-3 inline-flex items-center rounded bg-pink-500 px-2 py-1 text-xxs font-semibold uppercase text-white"
      >{{ $t('new') }}</span>
      <span
        class="relative mt-auto flex items-end justify-between space-x-6 bg-gradient-to-t from-gray-900 to-transparent p-5 pt-10 transition-all"
        :class="{ 'bg-gradient-to-t to-transparent': collection.image }"
      >
        <div>
          <p class="text-xs font-bold uppercase text-white/60">{{ $t('cobrand_and_share') }}</p>
          <Heading
            type="h3"
            variant="p"
            :ui="{ base: `mt-1 ${collection.image ? 'text-white' : 'text-paragraph'}` }"
            v-html="renderMarkdownInline(collection.name)"
          />
        </div>
        <span><Icon
          icon="long-arrow-right"
          class="text-white/60 transition-colors group-hover:text-white/90"
        /></span>
      </span>
    </span>

    <img
      v-if="!hidePartner && collection.partner.logo_url"
      :src="collection.partner.logo_url"
      :alt="collection.partner.name"
      class="mt-3 h-6"
    />
  </NuxtLink>
</template>

<script setup lang="ts">
const props = defineProps<{
  collection: ContentExperience
  hidePartner?: boolean
  allNew?: boolean
}>()

const { isLoggedIn } = useAuth()
</script>
